import { useEffect, useState } from "react";
import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import MuiCard from "@mui/material/Card";
import { PropTypes } from "prop-types";
import allServices, { categories } from "../../_mock/services";

const Card = ({ service }) => (
  <MuiCard
    sx={{
      height: 330
    }}
  >
    <img src={service.img} alt={service.name} height="50%" width="100%" />
    <Box p={2}>
      <Typography variant="body1">{service.name}</Typography>
      <Stack mt={1} ml={1} direction="row" sx={{ color: "gray" }}>
        {service.category === "Writing Services" ? (
          <>Pay per word</>
        ) : (
          <>
            &#x20B9;
            {service.price}
          </>
        )}
      </Stack>
      <Stack pt={1} direction="row" justifyContent="space-between">
        <Button variant="contained">View more</Button>
        <Button variant="contained">Order now</Button>
      </Stack>
    </Box>
  </MuiCard>
);

Card.propTypes = {
  service: PropTypes.object
};

const SelectButton = ({ category, setCategory, value }) => (
  <Button
    variant={category === value ? "contained" : "outlined"}
    onClick={() => setCategory(value)}
  >
    {value}
  </Button>
);

SelectButton.propTypes = {
  category: PropTypes.string,
  setCategory: PropTypes.func,
  value: PropTypes.string
};

export default function Services() {
  const [category, setCategory] = useState("All Services");
  const [services, setServices] = useState(allServices);

  useEffect(() => {
    if (category === "All Services") setServices(allServices);
    else setServices(allServices.filter((e) => e.category === category));
  }, [category]);

  return (
    <div>
      <Typography variant="h3" sx={{ textAlign: "center" }}>
        Explore The Marketplace
      </Typography>
      <Stack direction="row" spacing={4}>
        {categories.map((e, i) => (
          <SelectButton
            key={i}
            category={category}
            setCategory={setCategory}
            value={e}
          />
        ))}
      </Stack>

      <Box mt={4}>
        <Stack mb={2}>
          <Typography variant="h5">Digital Marketing Services</Typography>
        </Stack>
        <Grid container spacing={2}>
          {services.map((e, i) => (
            <Grid key={i} item xs={3}>
              <Card service={e} />
            </Grid>
          ))}
        </Grid>
        {/* <Stack my={8} alignItems="center">
          <Button
            variant="outlined"
            sx={{ width: 480 }}
            onClick={() => setCategory("")}
          >
            View all Services
          </Button>
        </Stack> */}
      </Box>
    </div>
  );
}
